import type { TimelineEvent } from '../../../src/runtime-contract';

export const inventoryBatch = (year: string) =>
  /^\d{4}$/.test(year)
    ? {
        key: `inventory-${year}`,
        title: `Housing inventory submitted · ${year}`,
      }
    : undefined;

/** Add display metadata to saved descriptors without changing source facts or identity. */
export function rentBoardTimelinePresentation(event: TimelineEvent): TimelineEvent {
  if (
    event.batch ||
    event.source !== 'sf-rent-board' ||
    event.entity.type !== 'sf-rent-board:submission' ||
    event.dateLabel !== 'Submitted'
  )
    return event;
  const year = event.fields['Reporting year'];
  return (typeof year === 'string' || typeof year === 'number') && /^\d{4}$/.test(String(year))
    ? { ...event, batch: inventoryBatch(String(year)) }
    : event;
}
